export { EditHomepageResource as default } from './resources';
